// Should stay in sync with timelineTypes.mjs
export const TIMELINE_TYPES = {
  ENROLLED: 0,
  DE_ENROLLED: 1
};
